import { render } from "./QuestionAttachments.vue?vue&type=template&id=59961f3c&scoped=true&ts=true"
import script from "./QuestionAttachments.vue?vue&type=script&lang=ts"
export * from "./QuestionAttachments.vue?vue&type=script&lang=ts"

import "./QuestionAttachments.vue?vue&type=style&index=0&id=59961f3c&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59961f3c"]])

export default __exports__